import {default as context} from 'util/context.js';
import {default as handler} from 'util/handler.js';
import {default as commentCount} from 'apps/comment-count/main.js';
import {default as debugModule} from 'util/debug.js';


const debug = debugModule(__filename);


commentCount.init({ autoRefresh: true }).then(() => {
    debug('Comment Count index script loaded');
});


module.exports = {
    handler,
    context
};


// WEBPACK FOOTER //
// ./src/bundles/index.js